import * as React from "react";
import TitleAndInfo from "../TitleAndInfo";
import languages from "../../language/languages";
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import {Button, Select, Row, Col} from "antd";
import {Field, reduxForm,formValueSelector } from "redux-form";
import {CreateCheckbox, CreateTextField} from "../../helpers/InputCreator";
import {commaequals, commaequalsen, email, emailen, required, requireden} from "../../helpers/validations";
import {connect} from "react-redux";
import requestCertificate from "../../actions/requestCertificate";
import countries from '../../language/countries';
import certificateTypes from "../../language/certificateTypes";
import getAllFields from "../../actions/getAllFields";
import {push} from "connected-react-router";
import generateP12 from "../../actions/generateP12";
import PrivateRoute from "../Main/PrivateRoute";
import PublicLayout from "../Layouts/Public";
import { getAreaCode, getCountryCA } from "../../Helpers/utils";

class CertRequest extends React.Component {
    preffix='_npki_';
    customFields=[];
    generateRequest = (form) =>
    {
        let general=this;
        let newForm={...form};
        let customFieldsJSON={};
        this.customFields.forEach(function(customField)
        {
            let oldKey=customField.id.split('.').join(general.preffix);
            let customValue=newForm[oldKey];
            delete newForm[oldKey];
            if(customField.type===1)
            {
                let customValues=JSON.parse(customField.values)[general.props.language].split(':');
                customValue=customValues[customValue];
            }
            customFieldsJSON[customField.id]=customValue;
        });
        let phone=newForm.telefono;
        if(phone && phone!=='' && !phone.startsWith('+'))
            phone='+'.concat(newForm.areaCode).concat('-').concat(phone);
        newForm.telefono=phone;
        delete newForm.areaCode;
        newForm.sendCodes=true;
        newForm.customFieldsJSON=JSON.stringify(customFieldsJSON);
        //console.log(newForm);
        this.props.requestCertificate(newForm);
    };

    componentDidMount() {
        this.props.getAllFields(this.initialize);
    }

    initialize= async (fields)=>
    {
        const country = await getCountryCA();
        const dialCode = await getAreaCode();
        let general=this;
        let initialValues={type: 'mime',country:country,areaCode:dialCode};
        let defaultFields=['type','cn','email','cedula','direccion','country','state','city','organization','organizationalUnit','areaCode','telefono'];
        fields.forEach(function(field)
        {
            if(!defaultFields.includes(field.id))
            {
                general.customFields.push(field);
                if(field.type===1)
                    initialValues[general.getNewID(field.id)] = "0";
            }

        });
        this.props.initialize(initialValues);
    };


    renderSelectOptions=(field)=>
    {
        if(field.type===0)
            return '';
        switch (field.id)
        {
            case "type":
                    return certificateTypes[this.props.language].map(item => item.code === 'ALL' ? '' : <Select.Option key={item.code}>{item.name}</Select.Option>);
            case "country":
                return countries.map(country =><Select.Option key={country.code}>{country.name}</Select.Option>);
            case "areaCode":
                return countries.map(country =>country.dialcode==='*'?'':<Select.Option key={country.dialcode}>({country.dialcode}) - {country.name}</Select.Option>);
            default:
                if(field.values)
                {
                    let jsonValues=JSON.parse(field.values)[this.props.language];
                    return jsonValues.split(':').map((value,index) => <Select.Option key={index}>{value}</Select.Option>);
                }
                return '';
        }
    };

    renderFormItem=(field,data) =>
    {
        data.input.onBlur=null;
        const hasError = data.meta.touched && data.meta.invalid;
        return <Form.Item
            label={data.label}
            className={data.icon ? '' : 'no-icon'}
            validateStatus={hasError ? "error" : "success"}
            hasFeedback={data.hasFeedback && hasError}
            help={hasError && data.meta.error}
            {...data.rest}
        ><Select label={data.label} {...data.input} {...data.rest}>{this.renderSelectOptions(field)}</Select></Form.Item>;
    };

    getNewID=(oldID)=>
    {
      return oldID.split('.').join(this.preffix);
    };

    renderFields= () =>
    {
        if(!this.props.fields || this.props.fields.length<=0)
            return '';
        let index=0;
        let rows=[];
        let cols=[];
        let spanLabelSize=4,fieldSize=20;
        if(window.innerWidth<600)
            spanLabelSize=fieldSize=24;
        this.props.fields.map((field,currentIndex)=> {
            let fieldLabel = languages[this.props.language][field.id];
            if(!fieldLabel||fieldLabel==='')
                fieldLabel=JSON.parse(field.label)[this.props.language];
            let newID=this.getNewID(field.id);
            let validations=[this.props.language === 'es'?commaequals:commaequalsen];
            if(field.required || (this.props.type==='mime' && field.id==='email') || (this.props.type!=='mime' && field.id==='cn'))
                validations.push(this.props.language === 'es' ? required : requireden);
            if(field.id==='email')
                validations.push(this.props.language === 'es'?email:emailen);
            cols.push(<Col style={{marginTop: 7}} span={spanLabelSize}>{fieldLabel}</Col>);
            cols.push(<Col span={fieldSize}><Field placeholder={fieldLabel} name={newID} component={field.type===0?CreateTextField:(data) => this.renderFormItem(field, data)}
                                           validate={validations} hasFeedback/></Col>);
            if (index === 0)
            {
                index = 1;
                if(currentIndex+1===this.props.fields.length)
                {
                    rows.push(cols);
                    cols=[];
                    index=0;
                }
            }
            else
            {
                rows.push(cols);
                cols=[];
                index=0;
            }
            return rows;
            });
        let result=rows.map((row)=><Row gutter={24}>{row}</Row>);
        if(this.props.type==='timestamp')
            result.push(<Row gutter={24}><Col style={{marginTop: 7}} span={spanLabelSize}>{languages[this.props.language].netcoTS}</Col>
                <Col span={fieldSize}><Field name={'importNetcoTS'} component={CreateCheckbox} hasFeedback/></Col></Row>);
        return <div>{result}</div>;
    };

    renderForm=()=>
    {
      return <Form onSubmit={this.props.handleSubmit(this.generateRequest)}>
        {this.renderFields()}
        <Form.Item className={'text-center mb-10'}>
            <Button  type="primary" htmlType="submit" className={'light-blue rounded'}>
                {languages[this.props.language].generateRequest}
            </Button>
        </Form.Item>
          {this.props.logged?'':<Form.Item className={'text-center'}>
              <Button onClick={()=>{this.props.push('/')}} type="primary" className={'light-blue rounded'}>
                  {languages[this.props.language].goBack}
              </Button>
          </Form.Item>}
        </Form>;
    };

    render() {
        if(this.props.logged)
        {
            return <div className="card-container h-100 p-20 tabs-container">
                {/*<TitleAndInfo info={languages[this.props.language].newRequestInfo}/>*/}

            {this.renderForm()}
        </div>;
        }
        return <PublicLayout size={'large'} isRA={this.props.isRA} title={'logo'}>
            <TitleAndInfo info={languages[this.props.language].newRequestInfo}/>
            {this.renderForm()}
        </PublicLayout>;

    }
}

const mapStateToProps = state => {
    const selector = formValueSelector('newReq_form');
    return {
        language: state.auth.language,
        logged:state.auth.logged,
        fields:state.certificates.fields,
        type:selector(state, 'type'),
        isRA:state.auth.isRA
    };
};

export default PrivateRoute(connect(mapStateToProps, {
    push,
    generateP12,
    getAllFields,
    requestCertificate
})((reduxForm({form: 'newReq_form'})(CertRequest))));
